import {Grid} from 'modules/ProductsGrid/components/Grid/Grid';
import {useProductsGridContainer} from 'modules/ProductsGrid/containers/ProductsGridContainer/useProductsGridContainer';
import {FC} from 'react';

import {Text} from 'components/Text/Text';

import styles from './ProductsGridContainer.module.css';

type Props = {};
export const ProductsGridContainer: FC<Props> = () => {
    const {
        makeHandleRemove,
        makeHandleRestore,
        makeHandleChangeCount,
        makeHandlePreviewClick,
        previewIsClickable,
        totals,
        groupsIds,
        groups,
        products,
    } = useProductsGridContainer();

    return (
        <div className={styles.block}>
            {/* <ComplectsAmountSelect
                options={hookResult.complectsAmountOptions}
                onSelect={hookResult.handleComplectsAmountSelect}
                selectedPlaceId={hookResult.selectedComplectsAmount}
                totalSum={hookResult.totals.summary.price.current}
                className={styles.complectsSelect}
            /> */}
            {/* <Text.Bold24 className={styles.title}>Оснащение</Text.Bold24> */}

            <Grid
                products={products}
                groupsIds={groupsIds}
                groups={groups}
                makeHandleRemove={makeHandleRemove}
                makeHandleRestore={makeHandleRestore}
                makeHandleChangeCount={makeHandleChangeCount}
                makeHandlePreviewClick={makeHandlePreviewClick}
                previewIsClickable={previewIsClickable}
                totals={totals}
            />
        </div>
    );
};
